import { Switch } from "@mui/material";
import {
  DatePickerComponent,
  TimePickerComponent,
  DateTimePickerComponent,
} from "@syncfusion/ej2-react-calendars";
import React, { useEffect, useRef, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import Successfull from "./Successfull";
import axios from "../../axios";
import ResponseLoding from "./ResponseLoding";
import ErrorDialog from "./ErrorDialogue";
import ComponentType from "../../Enum/ComponentTypeEnum";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import "react-datepicker/dist/react-datepicker.css";

const CreatePublish = ({
  setClick,
  questions,
  assessmentDetails,
  setAssessmentDetails,
  componentType,
  redirectStateData,
  isChecked,
  selectedBox,
}) => {
  const assessmentDialogRef = useRef();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [lectureDate, setLectureDate] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [isError, setIsError] = useState(true);
  const [success, setSuccess] = useState(false);
  const [dValid, setDValid] = useState(true);
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [pendingCreate, setPendingCreate] = useState(false);

  const today = new Date();
  const minDateTime = new Date(today.getTime() + 30 * 60000);
  const disablePastDates = (date) => {
    return date < today;
  };

  const [studentList, setStudentList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [lectures, setLectures] = useState();
  const [isInProgress, setIsInProgress] = useState(false);
  const [getTimeForHomeWork, setGetTimeForHomeWork] = useState("");
  const [existingAssessment, setExistingAssessment] = useState(null);
  const [showProcessingDialog, setShowProcessingDialog] = useState(false);
  let schoolId = JSON.parse(localStorage.getItem("schoolId"));
  let academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  let timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  const isHeavyAssessment = questions.length > 20;
  useEffect(() => {
    let students = [];
    const getStudentList = async () => {
      if (!timeTableSessionId) {
        return;
      }
      try {
        let res = await axios.get(
          `/api/v1/school/student/getList?standardId=${assessmentDetails?.standard_id?.id}&sectionId=${assessmentDetails?.section_id?.id}&timetableSession=${timeTableSessionId}`,
        );
        res &&
          res.data.data.map((student) =>
            students.push({ value: student.id, label: student.name }),
          );

        setStudentList(students);
      } catch (error) {
        console.log(error);
      }
    };

    assessmentDialogRef.current.closeDialog();
    getStudentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getLiveLectureList = async () => {
      if (!academicYearId || !timeTableSessionId) {
        toast.error(
          "These are no allocations set for your login. Please contact school admin for the assistance.",
        );
        return;
      }
      try {
        setLectures([]);
        if (lectureDate !== undefined && assessmentDetails?.deadline) {
          let lectures = await axios.get(
            `/api/v1/timetable/getLectureBySubject/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${assessmentDetails?.standard_id?.id}/sectionId/${assessmentDetails?.section_id?.id}/timetableSessionId/${timeTableSessionId}/subjectId/${assessmentDetails?.subject_id?.id}/date/${lectureDate}`,
          );
          lectures && setLectures(lectures?.data?.data[0]?.lectures);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getLiveLectureList();
  }, [lectureDate]);

  const handleStudentSelection = (selected) => {
    setSelectedList(selected);
  };

  function convertDateFormat(inputDate) {
    const [day, month, year] = inputDate.split("-");
    const dateObject = new Date(`${year}-${month}-${day}`);
    const convertedYear = dateObject.getFullYear();
    const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, "0");
    const convertedDay = String(dateObject.getDate()).padStart(2, "0");
    const convertedDate = `${convertedYear}-${convertedMonth}-${convertedDay}`;
    return convertedDate;
  }

  const dateHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${year}-${month}-${day}`;
    return outputDateString;
  };

  const timeHelper = (dateObj) => {
    if (!dateObj) return "";

    const hours = String(dateObj.getUTCHours()).padStart(2, "0");
    const minutes = String(dateObj.getUTCMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  const convertDateFormatLecSess = (date) => {
    const d = new Date(date);

    // Extract date components
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
    const day = String(d.getDate()).padStart(2, "0");

    // Extract time components
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    const outputDateString = `${hours}:${minutes}`;
    setGetTimeForHomeWork(outputDateString);

    return `${year}-${month}-${day}`;
  };

  const handleCreateAssessment = async () => {
    if (isHeavyAssessment) {
      setShowProcessingDialog(true);
    } else {
      setIsInProgress(true);
    }

    try {
      // 🔹 STEP 1: CHECK EXISTING (only first time)
      if (componentType === ComponentType.ASSESSMENT && !pendingCreate) {
        const standardId = assessmentDetails?.standard_id?.id;
        const sectionId = assessmentDetails?.section_id?.id;
        const deadline = assessmentDetails?.schedule_date;
        const scheduleTime = assessmentDetails?.schedule_time;
        const duration = assessmentDetails?.total_duration;
        try {
          const checkRes = await axios.get(
            `/api/v1/assessment/checkExisting?standardId=${standardId}&sectionId=${sectionId}&deadline=${deadline}&scheduleTime=${scheduleTime}&duration=${duration}`,
          );

          if (checkRes?.data?.status && checkRes?.data?.data) {
            setExistingAssessment(checkRes.data.data); // ✅ store data
            setShowConflictModal(true);
            setIsInProgress(false);
            return;
          } else {
            console.log("No existing assessment");
          }
        } catch (err) {
          console.log("Check existing error:", err);
        }
      }

      // 🔹 STEP 2: PREPARE QUESTIONS
      const updatedQuestions = questions.map((val) => {
        if (val.is_question_edited || val.id !== undefined) {
          delete val.id;
        }
        return val;
      });

      // 🔹 STEP 3: CREATE ASSESSMENT PAYLOAD
      let newAssessment = {
        name: assessmentDetails.name,
        description: assessmentDetails.description,
        type_id:
          componentType === ComponentType.ASSESSMENT
            ? null
            : assessmentDetails.type_id,
        assessmentTypeId: assessmentDetails.assessmentTypeId,
        assessmentEventId: assessmentDetails.assessmentEventId,
        ...(componentType === ComponentType.HOMEWORK
          ? {
              academic_session_id: academicSessionId,
              timetable_session_id: timeTableSessionId,
            }
          : {
              academicSessionId: academicSessionId,
              timetableSessionId: timeTableSessionId,
            }),
        standard_id: assessmentDetails.standard_id?.id,
        subject_id: assessmentDetails.subject_id?.id,
        teacher_id: assessmentDetails.teacher_id,
        section_id: assessmentDetails.section_id?.id,
        tags: assessmentDetails.tags,
        status: "published",
        total_duration: assessmentDetails.total_duration,
        deadline: assessmentDetails.deadline,
        schedule_date: assessmentDetails.schedule_date,
        schedule_time:
          componentType === ComponentType.ASSESSMENT
            ? assessmentDetails.schedule_time
            : getTimeForHomeWork,
        add_to_live_session: assessmentDetails.add_to_live_session,
        isAdaptive:
          selectedBox === "adaptive" ||
          selectedBox?.adaptive ||
          selectedBox?.isAdaptive
            ? true
            : false,
        autoEvalEnabled:
          selectedBox === "auto-evaluate" || selectedBox?.autoEvaluate
            ? true
            : false,
        questions: updatedQuestions,
      };

      // 🔹 STEP 4: STUDENT IDS
      let students_id = selectedList.map((student) => student.value);

      // 🔹 STEP 5: CREATE API
      let res = null;

      if (componentType === ComponentType.ASSESSMENT) {
        res = await axios.post(`/api/v1/assessment/create`, newAssessment);
      } else if (componentType === ComponentType.HOMEWORK) {
        res = await axios.post(`/api/v1/homework/create`, newAssessment);
      }

      // 🔹 STEP 6: STUDENT ASSIGNMENT
      if (res) {
        let newStudentAssessment = {
          teacher_id: assessmentDetails?.teacher_id,
          student_id: students_id,
          status: "pending",
          deadline: assessmentDetails?.deadline,
        };

        if (componentType === ComponentType.ASSESSMENT) {
          newStudentAssessment["totalDuration"] = parseInt(
            assessmentDetails?.total_duration,
          );
        }

        let studentRes = null;

        if (componentType === ComponentType.ASSESSMENT) {
          studentRes = await axios.post(
            `/api/v1/assessment/${res?.data?.data?.id}/studentAssessment/create`,
            newStudentAssessment,
          );
        } else if (componentType === ComponentType.HOMEWORK) {
          studentRes = await axios.post(
            `/api/v1/homework/${res?.data?.data?.id}/studentHomework/create`,
            newStudentAssessment,
          );
        }

        if (studentRes?.status === true) {
          setSuccess(true);
        }

        // 🔹 NAVIGATION
        if (redirectStateData !== null) {
          navigate("/liveSession", { state: redirectStateData });
        } else if (componentType === ComponentType.ASSESSMENT) {
          navigate("/publishedAssessment", { state: "fromAssessment" });
        } else {
          navigate("/PublishedHomework", { state: "fromHomework" });
        }
      }
    } catch (error) {
      setIsError(true);

      if (error.message === "No Internet Connection") {
        alert("No Internet Connection");
        return;
      }

      if (error?.response?.data?.message) {
        setErrorMessage(error?.response?.data?.message);
      }

      assessmentDialogRef.current.openDialog();
    } finally {
      if (pendingCreate) {
        setPendingCreate(false);
      }
      setIsInProgress(false);
      setShowProcessingDialog(false);

      if (componentType === ComponentType.ASSESSMENT) {
        localStorage.removeItem("temp_Questions_ASSESSMENT");
        localStorage.removeItem("currentStep");
        localStorage.removeItem("assessmentDetails");
        localStorage.removeItem("selectedBox");
      }

      if (componentType === ComponentType.HOMEWORK) {
        localStorage.removeItem("temp_Questions_HOMEWORK");
        localStorage.removeItem("currentStepHW");
        localStorage.removeItem("HomeWorkDetails");
      }
    }
  };

  console.log("existingAssesment", existingAssessment);
  console.log("Modal:", showConflictModal);

  const convertUTCToLocalTime = (timeStr) => {
    if (!timeStr) return "";

    const [hours, minutes] = timeStr.split(":").map(Number);

    const date = new Date();
    date.setUTCHours(hours);
    date.setUTCMinutes(minutes);

    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // 👈 AM/PM
    });
  };
  const handleDateChange = (selectedDate) => {
    console.log("selectedDate", selectedDate);

    if (selectedDate === null) {
      // clear case
      setDValid(false);
      setAssessmentDetails({
        ...assessmentDetails,
        deadline: "",
      });
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const selectedDateObject = new Date(selectedDate);
    selectedDateObject.setHours(0, 0, 0, 0);

    if (selectedDateObject < today) {
      setDValid(false);
      setAssessmentDetails({
        ...assessmentDetails,
        deadline: today.toLocaleDateString("en-CA").split("T")[0], // fallback to today
      });
    } else {
      setDValid(true);
      setAssessmentDetails((prevDetails) => ({
        ...prevDetails,
        deadline: selectedDate.toLocaleDateString("en-CA").split("T")[0], // store as yyyy-mm-dd
      }));
    }
  };

  const handleKeyDown = (e) => {
    const keyPressed = e.key;
    // Regular expression to allow only date-related characters
    const allowedCharacters = /[0-9/\-]/; // Adjust this regex based on your date format

    if (!allowedCharacters.test(keyPressed)) {
      e.preventDefault();
      setDValid(false);
    }
  };

  // const convertDateFormatLecSess = (date) => {
  //     console.log("Date", date)
  //     const d = new Date(date);
  //     const year = d.getFullYear();
  //     const month = String(d.getMonth() + 1).padStart(2, '0');
  //     const day = String(d.getDate()).padStart(2, '0');
  //     return `${year}-${month}-${day}`;
  // };

  const calculateMinTime = () => {
    if (assessmentDetails?.schedule_date) {
      const startDate = new Date(assessmentDetails.schedule_date);
      if (today.getDate() === startDate.getDate()) {
        startDate.setTime(today.getTime() + 30 * 60000);
      } else {
        startDate.setHours(0, 0, 0, 0);
      }
      return startDate;
    } else {
      // If no date is selected, start from current time + 30 minutes
      const now = new Date();
      now.setMinutes(now.getMinutes() + 30);
      return now;
    }
  };
  function formatDate(inputDate) {
    const dateObject = new Date(inputDate);

    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const deadline = assessmentDetails?.schedule_date;
  if (deadline) {
    var minLiveSessionDate = new Date(deadline);
    minLiveSessionDate.setDate(minLiveSessionDate.getDate() - 6);

    var maxLiveSessionDate = new Date(deadline);
    maxLiveSessionDate.setDate(maxLiveSessionDate.getDate() + 28);
  }
  function convertTimeStringToAMPM(timeString) {
    if (timeString.length !== 4) {
      // Ensure the input string has the correct length
      console.error("Invalid time string format");
      return null;
    }

    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2);

    const formattedTime = `${hours}:${minutes} ${hours < 12 ? "AM" : "PM"}`;
    return formattedTime;
  }

  return (
    <>
      <ErrorDialog
        error={
          ComponentType.ASSESSMENT == componentType
            ? "Cannot Create Assessment"
            : "Cannot Create Homework"
        }
        message={errorMessage}
        ref={assessmentDialogRef}
        setIsError={setIsError}
      />
      {!success && (
        <div className="publish_transprant_body1">
          <div className=" p-4 publish_white_containerPre">
            <img
              src="/images/cross-circle3.svg"
              className="subPrereadClosetBtn"
              alt=""
              onClick={(e) => setClick(false)}
            />
            <div className="PublishHeader">
              <h5 className="publish_header" style={{ margin: "0px" }}>
                Publish
              </h5>
              <p className="DisplayTag" style={{ margin: "0px" }}>
                <span style={{ fontWeight: "400" }}>Tags: </span>
                {assessmentDetails.tags.map((tag, index) => (
                  <span
                    style={{ color: "black", fontWeight: "600" }}
                    key={index}
                  >
                    {tag}
                    {index !== assessmentDetails.tags.length - 1 ? "," : ""}
                  </span>
                ))}
              </p>
            </div>
            <div className=" col-12 publish_field_boxs">
              {assessmentDetails?.subject_id?.name}
            </div>
            <div className=" col-12 publish_field_boxs">
              {assessmentDetails?.standard_id?.name}
            </div>
            <div className=" col-12 publish_field_boxs">
              {assessmentDetails?.section_id?.name}
            </div>
            <div className="my-3">
              <MultiSelect
                options={studentList}
                value={selectedList}
                onChange={handleStudentSelection}
                labelledBy="Select"
                overrideStrings={{ selectSomeItems: "Select Students" }}
                className="custom-multiselect w-100"
              />
              <span style={{ color: "red", fontSize: "10px" }}>
                {selectedList.length <= 0 && "Select atleast one student"}
              </span>
            </div>
            <div className="btn_containers">
              <div className="toggle_btn">
                {/* <div className="schedule_btns">
                                    <span>{ComponentType.ASSESSMENT === componentType ? "Schedule" : "Deadline"}</span>
                                    <label className="switch">
                                        <Switch
                                            className="switch"
                                            checked={checked}
                                            onChange={(event) => {
                                                setChecked(event.target.checked);
                                                setChecked1(false);

                                                setAssessmentDetails({
                                                    ...assessmentDetails,
                                                    schedule_date: null,
                                                    schedule_time: null,
                                                });
                                            }}
                                        />
                                    </label>
                                </div> */}
                {/* <div>
                                    {checked && (
                                        
                                    )}
                                </div> */}
                <>
                  {/* id css define in createPublishPreRead.css */}
                  {ComponentType.ASSESSMENT === componentType ? (
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "red",
                      }}
                    >
                      Scheduled Time (required)
                    </div>
                  ) : (
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "red",
                      }}
                    >
                      Deadline Date (required)
                    </div>
                  )}

                  {/* <DatePickerComponent
                    allowEdit={false}
                    min={today}
                    isDateDisabled={disablePastDates}
                    id="datepicker"
                    placeholder={
                      ComponentType.ASSESSMENT === componentType
                        ? "Scheduled date"
                        : "Deadline"
                    }
                    value={assessmentDetails?.schedule_date}
                    onChange={(e) => {
                      console.log(
                        "e.value:",
                        e.value,
                        "e.target.value:",
                        e.target?.value
                      );

                      // case 1: jab null aata hai
                      if (
                        !e.value ||
                        e.target?.value === "" ||
                        e.value === ""
                      ) {
                        console.log("thos code workied");
                        setAssessmentDetails({
                          ...assessmentDetails,
                          schedule_date: "",
                        });
                        setChecked1(false);
                      } else {
                        // hamesha date format me convert karo
                        setAssessmentDetails({
                          ...assessmentDetails,
                          schedule_date: convertDateFormatLecSess(e.value),
                        });
                      }

                      handleDateChange(e);
                    }}
                  /> */}
                  <DatePicker
                    selected={
                      assessmentDetails?.schedule_date
                        ? new Date(assessmentDetails.schedule_date)
                        : null
                    }
                    customInput={
                      <input
                        style={{
                          width: "100%",
                          height: "45px",
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          padding: "0 5px",
                          color: "#374151",
                        }}
                      />
                    }
                    onChange={(date) => {
                      if (!date) {
                        setAssessmentDetails({
                          ...assessmentDetails,
                          schedule_date: "",
                        });
                        setDValid(false);
                        setChecked1(false);
                        return;
                      }

                      // otherwise normal flow
                      setAssessmentDetails({
                        ...assessmentDetails,
                        schedule_date: convertDateFormatLecSess(date),
                      });
                      setDValid(true);

                      handleDateChange(date);
                    }}
                    minDate={today}
                    placeholderText={
                      ComponentType.ASSESSMENT === componentType
                        ? "Scheduled date"
                        : "Deadline"
                    }
                    isClearable
                    dateFormat="dd/MM/yyyy"
                  />

                  {ComponentType.ASSESSMENT === componentType && (
                    <div className="schedule_box" style={{ marginTop: "12px" }}>
                      <TimePickerComponent
                        min={calculateMinTime()}
                        isDateDisabled={disablePastDates}
                        id="timepicker"
                        placeholder="Scheduled time"
                        onChange={(e) => {
                          if (!e.target.value) {
                            setAssessmentDetails({
                              ...assessmentDetails,
                              schedule_time: "",
                            });
                            setChecked1(false);
                          } else {
                            setAssessmentDetails({
                              ...assessmentDetails,
                              schedule_time: timeHelper(e.target.value),
                            });
                          }
                        }}
                      />
                    </div>
                  )}
                  <span style={{ color: "red" }}>
                    {!dValid && "Min. date selected must be for today."}
                  </span>
                </>
              </div>
              <div className="toggle_btn">
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "blue",
                    marginLeft: "6px",
                  }}
                >
                  Link to Lecture Session (optional)
                </div>
                <div
                  className=" schedule_btns p-1 ml-1"
                  style={{ height: "48px" }}
                >
                  {deadline ? (
                    <div className="switch">
                      <DatePickerComponent
                        id="datepicker"
                        placeholder="Add to Lecture Session"
                        width={230}
                        value={lectureDate}
                        min={minLiveSessionDate}
                        max={maxLiveSessionDate}
                        // allowEdit={false}
                        onChange={(e) => {
                          let lecdate = e.target.value;
                          if (!lecdate) {
                            setLectureDate(null);
                          } else {
                            setChecked1(true);
                            setLectureDate(convertDateFormatLecSess(lecdate));
                          }
                        }}
                      />
                    </div>
                  ) : (
                    <>
                      <label className="deadlineNotSelect pb-1 pl-1">
                        Add to Lecture Session
                      </label>
                      <img
                        src="/images/calIconDow.png"
                        alt=""
                        className="calDow"
                      />
                    </>
                  )}
                </div>
                {checked1 && (
                  <div className="schedule_box border-0 p-0 ml-1">
                    <select
                      className="form-select col-12"
                      id="Schedule_sesion"
                      onChange={(e) =>
                        setAssessmentDetails({
                          ...assessmentDetails,
                          add_to_live_session: {
                            lecture_id: e.target.value,
                            date: convertDateFormat(
                              e.target.options[
                                e.target.selectedIndex
                              ].getAttribute("date"),
                            ),
                          },
                        })
                      }
                    >
                      <option selected>Select Lecture</option>
                      {lectures?.length > 0 &&
                        lectures?.map((lecture, index) => (
                          <option
                            key={index}
                            value={lecture.id}
                            date={lecture.date}
                          >
                            {lecture.name}, {lecture.date},{" "}
                            {convertTimeStringToAMPM(lecture.start_time)}-
                            {convertTimeStringToAMPM(lecture.end_time)}
                          </option>
                        ))}
                    </select>
                  </div>
                )}
              </div>
            </div>

            <div className="publish_btn_box">
              <button
                disabled={
                  !assessmentDetails.schedule_date ||
                  !selectedList.length > 0 ||
                  (checked1 &&
                    lectures?.length > 0 &&
                    (!assessmentDetails?.add_to_live_session?.lecture_id ||
                      !assessmentDetails?.add_to_live_session?.date)) ||
                  (ComponentType.ASSESSMENT === componentType &&
                    !assessmentDetails.schedule_time)
                }
                className="btn publish_btn"
                style={{ marginTop: "23px" }}
                onClick={handleCreateAssessment}
              >
                Publish
              </button>
            </div>
          </div>
        </div>
      )}
      {success && (
        <Successfull setSuccess={setSuccess} componentType={componentType} />
      )}
      {console.log("success", success)}
      {console.log("isInProgress", isInProgress)}
      {!success && isInProgress && !showProcessingDialog && <ResponseLoding />}

      {showConflictModal && (
        <Dialog
          open={showConflictModal}
          onClose={() => setShowConflictModal(false)}
          maxWidth="sm"
          fullWidth
        >
          {/* Title */}
          <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <WarningAmberIcon color="warning" />
            <Typography variant="h6" fontWeight="bold">
              Conflict Detected
            </Typography>
          </DialogTitle>

          <Divider />

          {/* Content */}
          <DialogContent>
            <Typography variant="body1" sx={{ mb: 2 }}>
              An assessment already exists at this scheduled time.
            </Typography>

            {existingAssessment && (
              <Box
                sx={{
                  background: "#f9fafb",
                  p: 2,
                  borderRadius: 2,
                  border: "1px solid #e5e7eb",
                }}
              >
                <Typography variant="body2">
                  <b>Name:</b> {existingAssessment?.name}
                </Typography>

                <Typography variant="body2">
                  <b>Schedule Time:</b>{" "}
                  {convertUTCToLocalTime(existingAssessment?.schedule_time)}
                </Typography>

                <Typography variant="body2">
                  <b>Duration:</b> {existingAssessment?.total_duration} mins
                </Typography>
              </Box>
            )}

            <Typography variant="body2" sx={{ mt: 2 }}>
              Do you still want to continue?
            </Typography>
          </DialogContent>

          <Divider />

          {/* Actions */}
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => setShowConflictModal(false)}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setShowConflictModal(false);
                setPendingCreate(true);
                handleCreateAssessment();
              }}
            >
              Continue
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {showProcessingDialog && (
        <Dialog open={true} maxWidth="xs" fullWidth>
          <DialogContent
            sx={{
              textAlign: "center",
              py: 4,
            }}
          >
            {/* Loader */}
            <Box sx={{ mb: 2 }}>
              <div className="spinner-border text-primary" />
            </Box>

            {/* Title */}
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Creating ...
            </Typography>

            {/* Message */}
            <Typography variant="body2" color="text.secondary">
              Please wait ⏳
              <br />
              This may take a 1-2 minutes due to large number of questions.
            </Typography>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default CreatePublish;
